import { services } from "api/serviceConfig";
import { makeAutoObservable } from "mobx";
import { Customer } from "models/users/Customer";
import { UserInfo } from "models/users/UserInfo";

export default class IdentityStore {
    constructor() {
        makeAutoObservable(this);
    }

    userInfo: UserInfo | undefined = undefined;
    currentCustomer: Customer | undefined = undefined;
    allCustomers: Customer[] = [];
    loading = false;

    get currentCustomerId() {
        return this.currentCustomer ? this.currentCustomer.id : -1;
    }

    get isGlobalUser() {
        return !this.userInfo?.customerId;
    }

    loadIdentity = async () => {
        this.loading = true;

        try {
            this.userInfo = (await services.UserManagement.getUserInfo()).data;

            if (this.userInfo.customerId) {
                this.currentCustomer = (await services.UserManagement.getCustomer(this.userInfo.customerId)).data;
            } else {
                this.allCustomers = (await services.UserManagement.getAllCustomers()).data;
                this.currentCustomer = this.allCustomers[0];
            }
        } catch (error) {
            console.log(error);
        } finally {
            this.loading = false;
        }
    };

    setCurrentCustomerByName = (name: string) => {
        this.currentCustomer = this.allCustomers.find((x) => x.name === name);
    };

    findCustomerByName = (name: string) => {
        return this.allCustomers.find((x) => x.name === name);
    };
}
